// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1334":"085bf444","5534":"085bf444","6533":"e997e87f","6765":"8724894a","6846":"085bf444"}[chunkId] + ".chunk.css";
};